import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { format, isValid, parseISO } from "date-fns";

const formatDateTime = value => {
  if (!value) return "-";
  const date = parseISO(value);
  if (!isValid(date)) return "-";
  return format(date, "dd/MM/yyyy HH:mm");
};

const formatStatus = status => {
  const labels = {
    pending: "Pendente",
    processing: "Processando",
    completed: "Concluído",
    completed_with_errors: "Concluído com erros",
    cancelled: "Cancelado",
    failed: "Falhou",
    sent: "Enviado"
  };

  return labels[String(status || "").toLowerCase()] || status || "-";
};

const ScheduledBroadcastDetailsModal = ({
  open,
  onClose,
  campaign,
  recipients,
  whatsApps,
  loading
}) => {
  const resolveWhatsappName = item => {
    if (item?.whatsapp?.name) return item.whatsapp.name;
    const fromContext = (whatsApps || []).find(
      w => Number(w.id) === Number(item?.whatsappId)
    );
    return fromContext?.name || `#${item?.whatsappId || "-"}`;
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Detalhamento da Campanha</DialogTitle>
      <DialogContent dividers>
        <div style={{ marginBottom: 12 }}>
          <strong>{campaign?.name || "-"}</strong>
          <div style={{ fontSize: 12, color: "rgba(0,0,0,0.65)", marginTop: 4 }}>
            Agendado para: {formatDateTime(campaign?.scheduledFor)} | Status:{" "}
            {formatStatus(campaign?.status)}
          </div>
          <div style={{ fontSize: 12, color: "rgba(0,0,0,0.65)", marginTop: 2 }}>
            Progresso: {campaign?.sentCount || 0}/{campaign?.totalContacts || 0} (falhas:{" "}
            {campaign?.failedCount || 0})
          </div>
        </div>

        <Paper variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Contato</TableCell>
                <TableCell>Telefone</TableCell>
                <TableCell>Instância</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Mensagem</TableCell>
                <TableCell>Erro</TableCell>
                <TableCell>Enviado em</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Carregando detalhes...
                  </TableCell>
                </TableRow>
              )}
              {!loading &&
                (recipients || []).map(item => (
                  <TableRow key={item.id}>
                    <TableCell>{item.contact?.name || "-"}</TableCell>
                    <TableCell>{item.contact?.number || "-"}</TableCell>
                    <TableCell>{resolveWhatsappName(item)}</TableCell>
                    <TableCell>{formatStatus(item.status)}</TableCell>
                    <TableCell>{item.message || "-"}</TableCell>
                    <TableCell>{item.error || "-"}</TableCell>
                    <TableCell>{formatDateTime(item.sentAt)}</TableCell>
                  </TableRow>
                ))}
              {!loading && !recipients?.length && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Nenhum item encontrado para esta campanha.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduledBroadcastDetailsModal;
